document.addEventListener('DOMContentLoaded', () => {
    
    if (typeof Swiper === 'undefined') return; 

    const swiperContainer = document.querySelector('.swiper-announcement-bar');
    if (!swiperContainer) return;

    const swiper = new Swiper(swiperContainer, {
        direction: 'vertical',
        loop: true,
        autoplay: {
            delay: 4000,
            disableOnInteraction: false,
            pauseOnMouseEnter: false,
        },
        slidesPerView: 1,
        spaceBetween: 0,
        speed: 800,
        
        // --- LOCK DOWN DRAGGING HERE ---
        allowTouchMove: false,  // Disables swiping/dragging on touch screens and desktops
        noSwiping: true         // Prevents any mouse dragging interactions completely
    });

    const playBtn = document.querySelector('.play-btn');
    const pauseBtn = document.querySelector('.pause-btn');
    const progressCircle = document.querySelector('.progress-circle circle');
    const counter = document.querySelector('.counter');
    
    const totalSlides = swiperContainer.querySelectorAll('.swiper-slide:not(.swiper-slide-duplicate)').length;
    
    let elapsedTime = 0;
    let animationFrame;
    let isPaused = false;

    function updateProgress() {
        if (isPaused) return;
        const startTime = performance.now() - elapsedTime;
        function animateProgress(currentTime) {
            if (isPaused) return;
            elapsedTime = currentTime - startTime;
            const progress = Math.min(elapsedTime / 4000, 1);
            if(progressCircle) {
                progressCircle.style.strokeDashoffset = 56.55 * (1 - progress);
            }
            if (progress < 1) {
                animationFrame = requestAnimationFrame(animateProgress);
            } else {
                elapsedTime = 0;
                swiper.slideNext();
            }
        }
        animationFrame = requestAnimationFrame(animateProgress);
    }

    function updateCounter() {
        if(!counter || totalSlides === 0) return;
        const currentSlide = swiper.realIndex + 1;
        counter.textContent = `${currentSlide}/${totalSlides}`;
    }

    // Initialize logic
    updateProgress();
    updateCounter();

    swiper.on('slideChange', () => {
        if (!isPaused) {
            elapsedTime = 0;
            updateProgress();
        }
        updateCounter();
    });

    if(pauseBtn && playBtn) {
        pauseBtn.addEventListener('click', () => {
            isPaused = true;
            swiper.autoplay.stop();
            document.querySelector('.announcement-bar-custom').classList.add('paused');
            pauseBtn.style.display = 'none';
            playBtn.style.display = 'block';
            cancelAnimationFrame(animationFrame);
            if(progressCircle) progressCircle.style.transition = 'none';
        });

        playBtn.addEventListener('click', () => {
            isPaused = false;
            swiper.autoplay.start();
            document.querySelector('.announcement-bar-custom').classList.remove('paused');
            playBtn.style.display = 'none';
            pauseBtn.style.display = 'block';
            updateProgress();
        });
    }
});